
import React, { useEffect, useState } from 'react'
import { LoadingPage } from '../components/PageLoading'
import { useAuth } from '../providers/AuthContext'

export const InstantSharePage = ({ instanceData }) => {

  const shareUrl = window.INSTANT_SHARE_ORIGIN  || 'https://shareservice-us-east-2.purview.net'

  const title = instanceData?.title || 'Purview Image - Share'
  const { isCheckingAuth, authUser } = useAuth()
  const [ isLoading, setIsLoading ] = useState(false)
  const [ jwtUserManegement, setJwtUserManegement ] = useState()
  const [ username , setUsername ] = useState()
  const [ url, setUrl] = useState()

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const _jwt = urlParams.get("jwt")
    setUrl(`${shareUrl}/share/${_jwt}`)
  }, [])

  useEffect(() => {
    const handleMessage = (e) => {
      try {
        const data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data
        if (data.type === 'favicon') {
          const existing = document.querySelector("link[rel*='icon']")
          if (existing) existing.remove()
          const link = document.createElement('link')
          link.rel = 'icon'
          link.type = 'image/png'
          link.href = data.href + '?v=' + Date.now()
          document.head.appendChild(link)
        }
      } catch (err) {}
    }
    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [])

  if (isLoading || !url) {
    return <><LoadingPage /></>
  }

  return <div style={{height: '100vh', overflow: 'hidden', background: 'white'}}>
    {/* <HeaderComponent /> */}
    <iframe 
      src={url} 
      // sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-top-navigation allow-top-navigation-by-user-activation allow-downloads"
      width={'100%'}  
      title={title} 
      style={{border: '0px', margin: '0px', padding: '0px', minHeight: '100%'}}>
    </iframe>
  </div>
}